import { render, staticRenderFns } from "./AlertCreate.vue?vue&type=template&id=a5b7af96&scoped=true"
import script from "./AlertCreate.vue?vue&type=script&lang=js"
export * from "./AlertCreate.vue?vue&type=script&lang=js"
import style0 from "./AlertCreate.vue?vue&type=style&index=0&id=a5b7af96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5b7af96",
  null
  
)

export default component.exports